/*
 * Copyright (c) 2022. Revo Digital
 * ---
 * Author: gabriele
 * File: EditorFeature.tsx
 * Project: mle-client-n
 * Committed last: 2022/5/5 @ 1028
 * ---
 * Description:
 */

import {Feature} from './Feature';
import {Editor} from '../../observables/Editor';

export abstract class EditorFeature<T> extends Feature<Editor, T, Editor> {
  protected constructor(name: string, editor: Editor) {
    super(name,
        editor,
        editor,
        true);
  }

  toString(): string {
    return 'EditorFeature ' + this.featureName;
  }
}